import React, { useContext, useState } from "react";
import { Formik, Field, Form } from 'formik';
import { AuthContext } from '../components/AuthContext';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Radio, TextField } from './form';
import UploadIcon from '@material-ui/icons/Upload'
import { makeStyles } from '@material-ui/styles'
import CheckIcon from '@material-ui/icons/Check';
import toast from 'react-hot-toast';
import { Backdrop, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from "@material-ui/core";
import MetamaskOnboarding from '@metamask/onboarding';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  helloMetamaskContainer: {
    maxWidth: 700,
    backgroundColor: 'white',
    position: 'absolute',
    padding: 15,
    border: '1px solid gray',
    borderRadius: 5,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  warn: {
    fontSize: 12,
    fontStyle: 'italic',
    padding: 0,
    margin: 0,
    opacity: 0.8
  },
  secret: {
    marginTop: 15
  },
  textField: {
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }
}));

export function CreateProductForm({ onSave }) {
  const { metamask, isLoggedIn, isConnected, login, connect, address } = useContext(AuthContext);
  const [status, setStatus] = useState(null);
  const [helloMetamask, setHelloMetamask] = useState(false);

  const onSubmit = async values => {
    if (!metamask) {
      setHelloMetamask(true);
      return;
    }

    let addr = address;
    setStatus('Creating...')

    if (!isConnected) {
      setStatus('Connecting to Metamask...')
      addr = await connect();
    }

    if (!isLoggedIn) {
      setStatus('Logging you in...')
      await login(addr);
    }

    setStatus('Creating your listing...')

    const payload = {
      title: values.title,
      price: values.price,
      description: values.description,
      enabled: true,
    };

    if (values.body) {
      payload.body = values.body;
    }

    if (values.file) {
      payload.file = values.file;
    }

    try {
      await onSave(payload);
      toast('Listing Created!');
    } catch (e) {
      console.log({e})
      if (e.response?.data?.message) {
        toast("Couldn't create the listing. " + e.response.data.message);
      } else {
        toast("Sorry, couldn't create the listing.")
      }
    }

    setStatus(null);
  }

  const doMetamaskOnboarding = () => {
    new MetamaskOnboarding().startOnboarding();
  };

  const classes = useStyles();

  let buttonText = '';
  let helperText = '';
  if (status) {
    buttonText = status
  } else if (isLoggedIn) {
    buttonText = 'Create Listing'
    helperText = undefined
  } else if (isConnected) {
    buttonText = 'Login & Create Listing'
    helperText = 'You will receive a Metamask prompt to login'
  } else {
    buttonText = 'Connect & Create Listing';
    helperText = 'You will receive 2 Metamask prompts, one to connect and another to sign in.';
  }

  return (
    <div className={classes.root}>
      <Dialog
        open={helloMetamask}
        onClose={() => setHelloMetamask(false)}
      >
        <DialogTitle id="alert-dialog-title" style={{textAlign: 'center'}}>
          <img alt="no" style={{ position: 'relative', bottom: -5 }} src={`${process.env.PUBLIC_URL}/metamask.svg`} width="100" /><br/>
          Looks like you don't have Metamask installed
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Metamask is the most popular browser based cryptocurrency wallet. It's free. You'll need it to transact on Crypto Broadway. Would you like to install it?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setHelloMetamask(false)} variant="outlined" color="primary">No</Button>{' '}
          <Button onClick={doMetamaskOnboarding} endIcon={<OpenInNewIcon/>} variant="contained" color="primary">Yes, Install It</Button>
        </DialogActions>
      </Dialog>

      <Formik
        initialValues={{
          title: '',
          price: '',
          body: '',
          productValueType: '',
          file: undefined,
        }}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <div>
              <Field
                component={TextField}
                className={classes.textField}
                label="Title"
                fullWidth
                type="text"
                name="title"
                margin="normal"
                placeholder="Defi Deep Dive: The Intelligent Investor's Guide"
                required
              />
            </div>

            <div className="form-group">
              <Field
                component={TextField}
                className={classes.textField}
                label="Price (ETH)"
                type="number"
                margin="normal"
                step="any"
                placeholder="1337"
                name="price"
                required
              />
            </div>

            <div role="group" aria-labelledby="my-radio-group">
              <label>What are you selling?</label>{' '}
              <label>
                <Field component={Radio} type="radio" name="productValueType" value="file" />A File
              </label>
              <label>
                <Field component={Radio} type="radio" name="productValueType" value="text" />Some Text
              </label>
            </div>

            {values.productValueType === 'text' && (
              <div className={classes.secret}>
                <Field
                  component={TextField}
                  label="Secret Contents"
                  fullWidth
                  multiline
                  type="text"
                  name="body"
                />
              </div>
            )}

            {values.productValueType === 'file' && (
              <div>
                  {values.file?.name ? (
                    <div>
                      <CheckIcon style={{position: 'relative', bottom: '-8'}} /> {values.file.name}{' '}
                      <Button
                        variant='outlined'
                        type="button"
                        onClick={event => {
                          setFieldValue('deleteFile', true);
                          setFieldValue('uploadedFile', undefined);
                          setFieldValue('file', undefined);
                        }}
                      >
                        Change
                      </Button>
                    </div>
                  ) : (
                    <Button
                      variant="contained"
                      color="secondary"
                      component="label"
                    >
                      <UploadIcon /> Choose a file...
                      <input
                        id="file"
                        type="file"
                        name="file"
                        hidden
                        onChange={(event) => {
                          setFieldValue("file", event.currentTarget.files[0]);
                        }}
                      />
                    </Button>
                  )}
              </div>
            )}

            <hr style={{opacity: 0.2, margin: 20}}/>

            <div>
                  <Button fullWidth variant="contained" size={'large'} type="submit">
                    {status && <CircularProgress size="15" color="info" />}
                    {buttonText}
                  </Button>
                  {helperText && <p className={classes.warn}>
                    <img alt="no" style={{ position: 'relative', bottom: -5 }} src={`${process.env.PUBLIC_URL}/metamask.svg`} width="20" />
                    {helperText}
                  </p>}
            </div>
            <Backdrop className={classes.backdrop} open={status !== null}>
              <CircularProgress size={25} color="inherit" />&nbsp;<h2>{status}</h2>
            </Backdrop>
          </Form>
        )}
      </Formik>
    </div>
  );
}
